/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Trans } from "react-i18next";

const Vision = () => {
  return (
    <section className="profilArea my-3">
      <div className="container">
        <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
            <ul className="fgaBreadcrumb">
              <li>
                <a href="/" style={{ verticalAlign: "middle" }}>
                  <span className="iconmford fo-icon-home"></span>
                </a>
              </li>
              <li>
                <a href="#" style={{ verticalAlign: "middle" }}>
                  <Trans desc="Kurumsal">10026</Trans>
                </a>
              </li>
              <li className="active">
                <Trans desc="Vizyon ve Misyon">10039</Trans>
              </li>
            </ul>
          </div>
        </div>
        <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
            <div className="profilBaslik">
              <Trans desc="Vizyon ve Misyon">10039</Trans>
            </div>
          </div>
        </div>
        <div className="row p-4 d-block">
          <div style={{ position: "relative", paddingTop: "56.25%" }}>
            <iframe
              src="https://player.vimeo.com/video/624191777?h=7917dc52d2"
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
              }}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="vision"
            ></iframe>
          </div>
        </div>
        <div className="row p-4 bottomRow align-items-center">
          <div className="col-xs-12 col-sm-12 col-md-6 order-md-1 col-lg-6 order-lg-1 order-1 p-0">
            <div
              className="visionImg"
              style={{ backgroundImage: "url('img/vizyon.jpg')" }}
            ></div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 order-md-2 col-lg-6 order-lg-2 order-2 aboutTextArea">
            <div className="aboutTitle">
              <Trans desc="Vizyon">10180</Trans>
            </div>
            <div className="aboutDesc">
              <Trans
                desc="Lider markamızın bayi çalışanlarına en üst seviyede eğitim ve
              gelişim imkanı sunarak, konusunda bir numaralı eğitim merkezi
              olmak."
              >
                10183
              </Trans>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 order-md-3 col-lg-6 order-lg-3 order-4 aboutTextArea mission">
            <div className="aboutTitle">
              <Trans desc="Misyon">10181</Trans>
            </div>
            <div className="aboutDesc">
              <Trans
                desc="Şirketimizin ve bayilerimizin ortak hedeflerine ulaşması için bayi
              çalışanlarının yetkinliğini en üst seviyeye taşımak ve markamıza
              olan bağlılığını arttırmak."
              >
                10184
              </Trans>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 order-md-4 col-lg-6 order-lg-4 order-3 p-0">
            <div
              className="visionImg"
              style={{ backgroundImage: "url('img/misyon.jpg')" }}
            ></div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 order-md-5 col-lg-6 order-lg-5 order-5 p-0">
            <div
              className="visionImg"
              style={{ backgroundImage: "url('img/politikamiz.jpg')" }}
            ></div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 order-md-6 col-lg-6 order-lg-6 order-6 aboutTextArea">
            <div className="aboutTitle">
              <Trans desc="Politikamız">10182</Trans>
            </div>
            <div className="aboutDesc">
              <Trans
                desc="Lider markamızın bayi çalışanlarına en üst seviyede eğitim ve
              gelişim imkanı sunarak, konusunda bir numaralı eğitim merkezi
              olmak."
              >
                10185
              </Trans>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
